import { Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

/**
 * The verdict, in the product's words rather than the model's — a spoken reply can read as
 * confirming what the outcome denies, and only the backend knows which sources were searched.
 */
export function VerdictLine({ text, dark }: { text: string; dark?: boolean }) {
  return (
    <Text size="textSm" fw={FONT_WEIGHTS.semibold} c={dark ? 'white' : 'gray.8'}>
      {text}
    </Text>
  );
}
